<template>
  <div class="logo-container" @click="toggleLogo" role="button" aria-label="Logo değiştir" tabindex="0">
    <div class="logo-stage">
      <img
        :src="bannerLogo"
        alt="developcu.com"
        class="logo logo-banner"
        :class="{ active: currentLogo === 0 }"
      />
      <img
        :src="iconLogo"
        alt="developcu"
        class="logo logo-icon"
        :class="{ active: currentLogo === 1 }"
      />
    </div>
  </div>
</template>

<script>
import bannerLogo from "@/assets/developcu.png";
import iconLogo from "@/assets/dc.png";

export default {
  name: "Temp",
  data() {
    return {
      currentLogo: 0,
      timer: null,
      bannerLogo,
      iconLogo,
    };
  },
  mounted() {
    this.startTimer();
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.currentLogo = this.currentLogo === 0 ? 1 : 0;
      }, 5000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    toggleLogo() {
      this.stopTimer();
      this.currentLogo = this.currentLogo === 0 ? 1 : 0;
      this.startTimer();
    },
  },
};
</script>

<style scoped>
.logo-container {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.logo-stage {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 620px;
  height: 220px;
}

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.96);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s ease-in-out, transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.8s;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  will-change: opacity, transform;
}

.logo.active {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1);
  pointer-events: auto;
}

/* Banner logo (developcu.png - 764x203) */
.logo-banner {
  width: 88vw;
  max-width: 560px;
  height: auto;
  max-height: 180px;
  object-fit: contain;
}

/* Emblem logo (dc.png - 1254x1254) */
.logo-icon {
  width: min(48vw, 220px);
  height: min(48vw, 220px);
  max-width: 220px;
  max-height: 220px;
  object-fit: contain;
}

/* Responsive adjustments for mobile devices */
@media (max-width: 600px) {
  .logo-stage {
    height: 180px;
  }

  .logo-banner {
    width: 86vw;
    max-width: 360px;
    max-height: 120px;
  }

  .logo-icon {
    width: min(45vw, 170px);
    height: min(45vw, 170px);
  }
}

@media (max-width: 360px) {
  .logo-stage {
    height: 150px;
  }

  .logo-banner {
    width: 90vw;
    max-width: 300px;
    max-height: 100px;
  }

  .logo-icon {
    width: min(48vw, 140px);
    height: min(48vw, 140px);
  }
}

/* Landscape mode for mobile devices */
@media (max-height: 500px) and (orientation: landscape) {
  .logo-stage {
    height: 130px;
  }

  .logo-banner {
    max-height: 90px;
  }

  .logo-icon {
    width: min(35vh, 130px);
    height: min(35vh, 130px);
  }
}
</style>
